import getTodoFolderStore from './getTodoFolderStore';
import { TodoFolder } from 'owa-todo-types';

export default function getTodoFolderById(folderId: string): TodoFolder {
    const todoFolderStore = getTodoFolderStore();
    const todoFolder = todoFolderStore.folders.get(folderId);

    return todoFolder;
}
